import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import moment from "moment";
import { Bar } from "react-chartjs-2";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import IconButton from "@material-ui/core/IconButton";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import Box from "@material-ui/core/Box";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import ForwardArrow from "@material-ui/icons/ArrowForward";
import BackwardArrow from "@material-ui/icons/ArrowBack";
import {
  amber,
  cyan,
  blue,
  purple,
  orange,
  teal,
  lime,
  brown,
} from "@material-ui/core/colors";

import Divider from "@material-ui/core/Divider";
import { downloadFileFromFolder, getFileFromFolder } from "../firebaseApi";
import { Typography } from "@material-ui/core";

import InstructorPollDelete from "./InstructorPollDelete";
import InstructorPollResume from "./InstructorPollResume";
import InstructorPollCheat from "./InstructorPollCheat";
import { getPollData, getGraphData } from "./utils";

const shade = 200;
const colors = [
  amber[shade],
  cyan[shade],
  blue[shade],
  purple[shade],
  orange[shade],
  teal[shade],
  lime[shade],
  brown[shade],
];

const styles = (theme) => ({
  card: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  cardMobile: {
    paddingTop: "20px",
  },
  bar: {
    height: 320,
  },
  image: {
    height: 320,
  },
  skeleton: {
    height: 320,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#dfdfdf",
  },
  screenshot: {
    objectFit: "contain",
    width: "100%",
    height: "100%",
  },
  votebuttons: {
    paddingLeft: "10px",
  },
  pollText: {
    paddingLeft: 41.5,
    paddingRight: 41.5,
  },
  pollTextMobile: {
    paddingLeft: 15,
    paddingRight: 35,
  },

  listItem0: { backgroundColor: colors[0] + "!important" },
  listItem1: { backgroundColor: colors[1] + "!important" },
  listItem2: { backgroundColor: colors[2] + "!important" },
  listItem3: { backgroundColor: colors[3] + "!important" },
  listItem4: { backgroundColor: colors[4] + "!important" },
  listItem5: { backgroundColor: colors[5] + "!important" },
  listItem6: { backgroundColor: colors[6] + "!important" },
  listItem7: { backgroundColor: colors[7] + "!important" },
});

function InstructorPoll(props) {
  //let mobile = props.width === "sm" || props.width === "xs";
  let pollMax = 0;
  if (props.polls != null) {
    pollMax = props.polls.length;
  }
  const [categoryAnchorEl, setCategoryAnchorEl] = React.useState(null);
  const [pollDelete, setPollDelete] = React.useState({
    anchorEl: null,
    open: false,
  });
  const [pollCheat, setPollCheat] = React.useState({
    anchorEl: null,
    open: false,
  });
  const [pollResume, setResumePoll] = React.useState({
    anchorEl: null,
    open: false,
  });
  const [categoryName, setCategoryName] = React.useState(
    props.persistentCategory ? props.persistentCategory : null
  );
  const [optionsConfig, setOptionsConfig] = React.useState(
    props.persistentOptions
      ? JSON.parse(JSON.stringify(props.persistentOptions))
      : []
  );
  const [pollScreenshot, setPollScreenshot] = React.useState(null);
  const componentRef = React.useRef(null);
  const chartRef = React.useRef(null);
  const [mobile, setIsMobile] = React.useState(false);

  let voteButtons = (fullWidth) => (
    <ButtonGroup fullWidth={fullWidth} className={props.classes.votebuttons}>
      {["A", "B", "C", "D", "E"].map((choice) => (
        <Button
          disabled={props.poll.pollAnonymous}
          key={choice}
          color={props.poll?.answer === choice ? "primary" : "default"}
          variant={props.poll?.answer === choice ? "contained" : "outlined"}
          onClick={() => {
            props.poll?.answer === choice
              ? props.unsetAnswer()
              : props.setAnswer(choice);
          }}
        >
          {choice}
        </Button>
      ))}
    </ButtonGroup>
  );

  // Function to dynamically change the poll window size to mobile
  React.useEffect(() => {
    const checkSize = () => {
      if (componentRef.current && componentRef.current.offsetWidth) {
        setTimeout(() => {
          if (componentRef.current?.offsetWidth) {
            const width = componentRef.current.offsetWidth;
            setIsMobile(width <= 600);
          }
        }, 200);
      }
    };

    checkSize();

    window.addEventListener("resize", checkSize);

    return () => window.removeEventListener("resize", checkSize);
  }, [props.userMenuOpen, props.sessionMenuOpen]);
  // Function to resize the chart after poll window size change
  React.useEffect(() => {
    if (chartRef.current && chartRef.current.chartInstance) {
      setTimeout(() => {
        if (chartRef.current && chartRef.current.chartInstance) {
          chartRef.current.chartInstance.resize();
        }
      }, 200);
    }
  }, [props.userMenuOpen, props.sessionMenuOpen, mobile]);

  // Get and display screenshots
  React.useEffect(async () => {
    //should check if user also has access to screenshots
    if (!props.course.screenshotsEn || !props.driveInit) return;

    const fileName = `Webclicker-${props.poll.pollID}.png`;
    const courseFolderID = props.course.googleDriveFolderID;
    const fileID = await getFileFromFolder(fileName, courseFolderID);

    if (fileID == null) return;

    const screenshotURL = await downloadFileFromFolder(fileID);
    setPollScreenshot(screenshotURL);
  }, [props.screenshotRender, props.course.screenshotsEn, props.poll.screenshotAvailable, props.driveInit]);

  React.useEffect(() => {
    if (!props.sessionActive) {
      setCategoryName(props.globalCategory);
      setOptionsConfig(props.globalOptions);
    }
  }, [props.globalCategory]);

  return (
    <div ref={componentRef}>
      <Card
        className={mobile ? props.classes.cardMobile : props.classes.card}
        elevation={0}
      >
        <ListItem>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ListItemAvatar
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: props.poll.pollAnonymous || props.poll.pollLock ? "10px" : null,
              }}
            >
              <Avatar style={{ borderRadius: 0 }}>
                {props.poll.pollIndex}
              </Avatar>
            </ListItemAvatar>
            {!props.poll.pollAnonymous ? null : (
              <Typography variant="caption" style={{ fontSize: "8px" }}>
                Anonymous
              </Typography>
            )}
            {!props.poll.pollLock ? null : (
              <Typography variant="caption" style={{ fontSize: "10px", color: "red" }}>
                Lockout
              </Typography>
            )}
          </div>

          <ListItemText
            style={{ marginLeft: "10px" }}
            primary={moment(Number(props.poll.pollStartTime)).format(
              "ddd, MMM Do YYYY, H:mm"
            )}
            secondary={
              !Object.values(props.poll.students).length
                ? ""
                : Object.keys(props.poll.students).length + " Student Responses"
            }
          />

          <Button
            disabled={!props.sessionActive}
            onClick={(event) => {
              props.setShowDisplayInactive(
                !(props.pollActive && props.displayLive)
              );
            }}
            style={{
              backgroundColor:
                props.pollActive && props.displayLive
                  ? "rgba(245,0,87,255)"
                  : "white",
              color: !props.sessionActive
                ? "gray"
                : props.pollActive && props.displayLive
                ? "white"
                : "black",
              cursor: !props.sessionActive ? "not-allowed" : "pointer",
            }}
          >
            {props.pollActive && props.displayLive ? "Hide" : "Show"}
          </Button>

          <IconButton
            onClick={(event) => {
              setPollDelete({ ...pollDelete, anchorEl: event.currentTarget });
            }}
          >
            <MoreVertOutlinedIcon />
          </IconButton>

          {mobile ? null : (
            <Button
              variant="outlined"
              onClick={(event) => {
                setCategoryAnchorEl(event.currentTarget);
              }}
            >
              {!categoryName ? "Category" : categoryName}
            </Button>
          )}
          {mobile ? null : voteButtons(false)}
        </ListItem>

        <Grid
          style={{
            marginTop: optionsConfig.length > 0 ? 0 : 40,
            marginBottom: optionsConfig.length > 0 ? 4 : 0,
          }}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
        >
          {optionsConfig.map((option, index) => {
            let listItemStyle = "listItem" + option.index;
            return (
              <Grid item key={index}>
                <List style={{ padding: 0 }}>
                  <ListItem
                    classes={{ selected: props.classes[listItemStyle] }}
                    dense
                    button
                    selected={option.checked}
                    onClick={() => {
                      let newOptionsConfig = optionsConfig.slice();
                      newOptionsConfig[index].checked = !option.checked;
                      setOptionsConfig(newOptionsConfig);

                      props.setPersistentOptions(newOptionsConfig);
                      props.setGlobalOptions(newOptionsConfig);
                    }}
                  >
                    <ListItemText primary={option.optionName} />
                    <ListItemSecondaryAction>
                      <IconButton
                        style={{ padding: 8 }}
                        edge="end"
                        onClick={() => {
                          let newOptionsConfig = optionsConfig.slice();
                          newOptionsConfig[index].checked = !option.checked;
                          setOptionsConfig(newOptionsConfig);

                          props.setPersistentOptions(newOptionsConfig);
                          props.setGlobalOptions(newOptionsConfig);
                        }}
                      >
                        {option.checked ? <RemoveIcon /> : <AddIcon />}
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>{" "}
              </Grid>
            );
          })}
        </Grid>

        <Grid container spacing={1}>
          <Grid item md={mobile ? 12 : 6} xs={12}>
            <Paper className={props.classes.bar} elevation={0}>
              <Bar
                ref={chartRef}
                data={getGraphData(
                  getPollData(
                    props.poll.students,
                    categoryName,
                    props.poll.pollCategories[categoryName]
                  ),
                  props.poll,
                  categoryName,
                  optionsConfig
                )}
                redraw={true}
                options={{
                  maintainAspectRatio: false,
                  animation: false,
                  responsive: true,
                  scales: {
                    xAxes: [
                      {
                        stacked: true,
                      },
                    ],
                    yAxes: [
                      {
                        stacked: true,
                        suggestedMin: 0,
                        ticks: {
                          min: 0,
                          max: 100,
                          callback: (value) => value + "%",
                        },
                      },
                    ],
                  },
                }}
                legend={{ display: false }}
              />
            </Paper>
          </Grid>
          {!mobile ? null : (
            <>
              <Button
                fullWidth
                variant="outlined"
                onClick={(event) => {
                  setCategoryAnchorEl(event.currentTarget);
                }}
              >
                {!categoryName ? "Category" : categoryName}
              </Button>
              <ListItem>{voteButtons(true)}</ListItem>
            </>
          )}

          <Grid item md={mobile ? 12 : 6} xs={12}>
            <Paper className={props.classes.bar} elevation={0}>
              {pollScreenshot ? (
                <img
                  src={pollScreenshot}
                  className={props.classes.screenshot}
                />
              ) : (
                <div className={props.classes.skeleton}>
                  <Typography>Screenshot Unavailable</Typography>
                </div>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Card>

      <Menu
        id="category-menu"
        anchorEl={categoryAnchorEl}
        open={Boolean(categoryAnchorEl)}
        onClose={() => {
          setCategoryAnchorEl(null);
        }}
      >
        <MenuItem
          button={true}
          key="None"
          onClick={() => {
            setCategoryAnchorEl(null);
            setCategoryName(null);
            setOptionsConfig([]);

            props.setPersistentCategory(null);
            props.setGlobalCategory(null);
            props.setPersistentOptions(null);
            props.setGlobalOptions([]);
          }}
        >
          None
        </MenuItem>

        {Object.keys(props.poll.pollCategories).map((categoryName) => (
          <MenuItem
            button={true}
            key={categoryName}
            onClick={() => {
              let optionNames = props.poll.pollCategories[categoryName];

              let newOptionsConfig = [];
              optionNames.concat(["Unknown"]).forEach((optionName, index) => {
                newOptionsConfig.push({
                  optionName: optionName,
                  checked: true,
                  index: index,
                });
              });

              setCategoryAnchorEl(null);
              setCategoryName(categoryName);
              setOptionsConfig(newOptionsConfig);

              props.setPersistentCategory(categoryName);
              props.setGlobalCategory(categoryName);
              props.setPersistentOptions(newOptionsConfig);
              props.setGlobalOptions(newOptionsConfig);
            }}
          >
            {categoryName}
          </MenuItem>
        ))}
      </Menu>

      <Menu
        anchorEl={pollDelete.anchorEl}
        open={pollDelete.anchorEl !== null}
        onClose={() => {
          setPollDelete({ ...pollDelete, anchorEl: null });
        }}
      >
        { (props.selRole === "instructor" || props.course?.taPrivileges?.includes("Delete Polls")) ? <MenuItem
          button={true}
          onClick={() => {
            setPollDelete({ anchorEl: null, open: true });
          }}
        >
          Delete poll
        </MenuItem> : null}
        <MenuItem
          button={true}
          disabled={!props.sessionActive}
          onClick={() => {
            setPollDelete({ ...pollDelete, anchorEl: null });
            setResumePoll({ anchorEl: null, open: true });
          }}
        >
          Resume poll
        </MenuItem>
        
        { props.course?.lockedPolls && (props.selRole === "instructor" || props.course?.taPrivileges?.includes("Open Lockout Polls")) ? <MenuItem
        button={true}
        disabled = {!(props.course.courseActivityPollID === props.poll.pollID) || props.poll.pollLock}
        onClick={()=>{
          setPollCheat({anchorEl:null, open:true})
          setPollDelete({ ...pollDelete, anchorEl: null });
        }}
        >
          Set as lockout poll
        </MenuItem> : null}
      </Menu>

      <InstructorPollDelete
        key={"Delete " + pollDelete.open}
        open={pollDelete.open}
        openCtl={(open) => {setPollDelete({ ...pollDelete, open })}}
        pollNumber={props.poll.pollIndex}
        delete={() => props.deletePoll(props.poll.pollID)}
      />

      <InstructorPollResume
        key={"Resume " + pollResume.open}
        open={pollResume.open}
        openCtl={(open) => {setResumePoll({ ...pollResume, open })}}
        pollNumber={props.poll.pollIndex}
        resume={() => props.resumePoll(props.poll.pollID)}
      />

      
      <InstructorPollCheat
        key={"Do Lockout Vote " + pollCheat.open}
        open={pollCheat.open}
        openCtl={(open) => {setPollCheat({ ...pollCheat, open })}}
        pollNumber={props.poll.pollIndex}
        course = {props.course}
        lock = {()=>{props.setLock();props.setRender();}}
      />
    <Divider />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
    selRole: state.selRole,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorPoll))
  )
);
